export default class ColumnSwiper {
    constructor(elm, args) {
        const container = elm.parentNode;
        if (!args?.ignoreSlider) {
            const controls = container.querySelector('.column-slider__controls');
            let slidesPerViewMobile = args?.slidesPerViewMobile ? args?.slidesPerViewMobile : 1.5;
            slidesPerViewMobile = args?.eventSlider ? 1.2 : slidesPerViewMobile;
            let testChange = 2;

            const options = {
                loop: false,
                slidesPerView: slidesPerViewMobile,
                spaceBetween: 15,
                observer: true,
                observeParents: true,
                watchSlidesVisibility: true,
                watchOverflow: true,
                pagination: {
                    el: container.querySelector('.swiper-pagination'),
                    type: 'fraction',
                    formatFractionCurrent: number => (number < 10 ? '0' : '') + number,
                    formatFractionTotal: number => (number < 10 ? '0' : '') + number,
                },
                navigation: {
                    nextEl: container.querySelector('.swiper-button-next'),
                    prevEl: container.querySelector('.swiper-button-prev'),
                },
                scrollbar: {
                    el: container.querySelector('.swiper-scrollbar'),
                    draggable: true,
                    snapOnRelease: true,
                },
                breakpoints: {
                    500: {
                        slidesPerView: 1.5,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1837: {
                        slidesPerView: args?.slidesPerViewDesktop ? args?.slidesPerViewDesktop : 4,
                        spaceBetween: 30,
                    },
                },
                on: {
                    beforeResize: (e) => {
                        controls.classList.toggle('column-slider__controls--locked', e.isLocked);
                    },
                    init: (e) => {
                        controls.classList.toggle('column-slider__controls--locked', e.isLocked);
                    },
                },
            };

            const initializeSwiper = () => {
                import('swiper').then(({ Swiper, Navigation, Pagination, Scrollbar }) => {
                    Swiper.use([Navigation, Pagination, Scrollbar]);
                    this.swiper = new Swiper(elm, options);
                });
            };

            if (!args?.enabledBreakpoint) {
                initializeSwiper();
            } else {
                import('lodash/throttle').then(throttleImport => {
                    const onWindowResize = () => {
                        if (window.innerWidth < args?.enabledBreakpoint) {
                            if (!this.swiper || this.swiper.destroyed) {
                                initializeSwiper();
                            }
                        } else if (this.swiper) {
                            this.swiper.destroy();
                        }
                    };
                    const throttledOnWindowResize = throttleImport.default(onWindowResize, 100);
                    window.addEventListener('resize', throttledOnWindowResize);
                    onWindowResize();
                });
            }
        }

        const infoLinksElms = container.querySelectorAll('[data-event-page__info-link]');
        const infoSlideInModalElm = container.closest('.page-container, .container').querySelector('[data-event-page__info-slide-in-modal]');

        if (infoLinksElms && args?.openInOverlay) {
            import('../components/slide-in-modal').then(({ default: SlideInModal }) => {
                let infoSlideInModal;
                infoLinksElms.forEach(le => {
                    const sectionKey = le.getAttribute('data-event-page__info-link');
                    le.addEventListener('click', () => {
                        if (infoSlideInModal) {
                            infoSlideInModal.open(sectionKey);
                        } else if (infoSlideInModalElm) {
                            infoSlideInModal = new SlideInModal(infoSlideInModalElm);
                            infoSlideInModal.open(sectionKey);
                        }
                    });
                });
            });
        }
    }
}
